import type { DonationFormValues } from '@/donationForm/types';
import type { processDonationFormAction } from '@/donationPages/_dependencies/operations/processDonationAction';
import { useActionFormContext } from '@/form/ActionForm';
import { OperationReturn } from '@/helpers/operations';
function useDonationFormContext() {
  return useActionFormContext();
}
export default useDonationFormContext;